import React from 'react';
import {
  PawPrint,
  IndianRupee,
  Settings,
  FileText,
  BarChart3,
  MessageSquare,
  Mail,
  Lightbulb,
  AlertTriangle,
  Check,
  X,
  Infinity,
  Star,
  MapPin,
  Palette,
  Plug,
  Clock,
  BadgeCheck,
  TrendingUp,
  Circle,
  Crown,
  Users,
  Headphones,
  Shield,
  Lock,
  Package,
  Handshake,
  Calendar,
  Ticket,
  KeyRound,
} from 'lucide-react';

const iconClass = (size) => {
  if (size === 'sm') return 'w-3.5 h-3.5';
  if (size === 'lg') return 'w-5 h-5';
  return 'w-4 h-4';
};

/** Map legacy emoji / keys to Lucide SVG icons for admin UI */
export const AdminIcon = ({ name, size = 'md', className = '' }) => {
  const cls = `${iconClass(size)} ${className}`.trim();

  switch (name) {
    case 'paw':
    case '🐾':
      return <PawPrint className={cls} strokeWidth={2} />;
    case 'money':
    case '💰':
      return <IndianRupee className={cls} strokeWidth={2} />;
    case 'settings':
    case '⚙️':
      return <Settings className={cls} strokeWidth={2} />;
    case 'edit':
    case '📝':
      return <FileText className={cls} strokeWidth={2} />;
    case 'chart':
    case '📊':
      return <BarChart3 className={cls} strokeWidth={2} />;
    case 'support':
    case '💬':
    case '🎧':
      return <Headphones className={cls} strokeWidth={2} />;
    case 'mail':
    case '📧':
      return <Mail className={cls} strokeWidth={2} />;
    case 'tip':
    case '💡':
      return <Lightbulb className={cls} strokeWidth={2} />;
    case 'warn':
    case '⚠️':
      return <AlertTriangle className={cls} strokeWidth={2} />;
    case 'check':
    case '✅':
    case '✓':
      return <Check className={cls} strokeWidth={2.5} />;
    case 'x':
    case '✗':
      return <X className={cls} strokeWidth={2.5} />;
    case 'infinity':
    case '♾️':
      return <Infinity className={cls} strokeWidth={2} />;
    case 'star':
    case '⭐':
      return <Star className={cls} strokeWidth={2} />;
    case 'pin':
    case '📍':
      return <MapPin className={cls} strokeWidth={2} />;
    case 'palette':
    case 'brush':
    case '🎨':
      return <Palette className={cls} strokeWidth={2} />;
    case 'api':
    case '🔌':
      return <Plug className={cls} strokeWidth={2} />;
    case 'time':
    case '⏱️':
      return <Clock className={cls} strokeWidth={2} />;
    case 'verified':
      return <BadgeCheck className={cls} strokeWidth={2} />;
    case 'analytics':
    case '📈':
      return <TrendingUp className={cls} strokeWidth={2} />;
    case 'online':
    case '🟢':
      return <Circle className={`${cls} fill-emerald-500 text-emerald-500`} strokeWidth={0} />;
    case 'offline':
    case '🔴':
      return <Circle className={`${cls} fill-red-500 text-red-500`} strokeWidth={0} />;
    case 'lock':
    case '🔒':
    case '🔐':
      return <Lock className={cls} strokeWidth={2} />;
    case 'crown':
    case '👑':
      return <Crown className={cls} strokeWidth={2} />;
    case 'users':
    case '👥':
      return <Users className={cls} strokeWidth={2} />;
    case 'shield':
    case '🛡️':
      return <Shield className={cls} strokeWidth={2} />;
    case 'package':
    case '📦':
      return <Package className={cls} strokeWidth={2} />;
    case 'handshake':
    case '🤝':
      return <Handshake className={cls} strokeWidth={2} />;
    case 'calendar':
    case '📅':
      return <Calendar className={cls} strokeWidth={2} />;
    case 'ticket':
    case '🎟️':
      return <Ticket className={cls} strokeWidth={2} />;
    case 'key':
      return <KeyRound className={cls} strokeWidth={2} />;
    default:
      return <Shield className={`${cls} opacity-40`} strokeWidth={2} />;
  }
};

export const AdminSectionBadge = ({ icon, children, className = '' }) => (
  <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium ${className}`}>
    <AdminIcon name={icon} size="sm" />
    {children}
  </span>
);

export const AdminLabelWithIcon = ({ icon, children, className = '' }) => (
  <span className={`inline-flex items-center gap-1.5 ${className}`}>
    <AdminIcon name={icon} size="sm" />
    {children}
  </span>
);

export default AdminIcon;
